import { optimXAdminInfoId } from '../../catalog/Others';
import { db } from '../FirebaseLibrary';

export const createOptimXAdminInfoReference = (teamId: string) => {
    return db.collection(`teams/${teamId}/read-only`).doc(optimXAdminInfoId);
};

// Read twice per page load (ads flag, then the activation check): share one request. A failed read
// is dropped so the next caller retries.
const adminInfoReads = new Map<string, Promise<any>>();

export const fetchOptimXAdminInfoFirestoreAPI = (teamId: string) => {
    const hit = adminInfoReads.get(teamId);
    if (hit) return hit;
    const read = createOptimXAdminInfoReference(teamId).get();
    adminInfoReads.set(teamId, read);
    read.catch(() => { adminInfoReads.delete(teamId); });
    return read;
};
